/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable no-duplicate-imports */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/class-name-casing */
import { makeAutoObservable, configure } from 'mobx';
import request from './utils/request';
import { Modal, Toast } from 'antd-mobile';
import { isWeiBo, isWeiXinAndQQ, isWeiXin } from './utils/utils';
import { Link } from 'preact-router/match';
import trim from 'lodash/trim';
import UM from './utils/UM';
import { toPairsIn } from 'lodash';
import copy from 'copy-to-clipboard';
const openModal = (data: any) => {
  let module: any = null
  module = Modal.show({
    title: "温馨提示",
    showCloseButton: true,
    content: "宝首次参与积分活动，需要点击复制活动链接去微信打开哦，活动结束后兑奖通过微信发放，不然我就找不到你兑奖啦！点击一次授权后微博和微信两边都能参与～",
    actions: [{
      key: 'online',
      text: '点击复制链接',
      primary: true,
      style: { backgroundColor: "#F05F2C", color: "#fff", border: "none" },
      onClick: () => {
        copy(data.data.bind_url)
        module?.close();
        Toast.show('复制成功，请前往微信打开链接,完成绑定');
      }
    }]
  })
}
configure({
  enforceActions: 'never',
});
class store {
  constructor() {
    makeAutoObservable(this);
  }
  hasPage = false;
  pointLoading = false;
  postPointsExchange = async (params: any, callBack: any) => {
    if (!params.platform) {
      Toast.show('请选择兑换平台');
      return;
    }
    if (!params.order_id) {
      Toast.show('请输入兑换订单号');
      return;
    }
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get('gh_id')) {
      params.gh_id = searchParams.get('gh_id')
    }
    this.pointLoading = true;
    const res: any = await request(`api/points/exchange`, {
      method: 'POST',
      data: params,
    });
    this.pointLoading = false;
    if (res.err) {
      if (`${res.err}` != 'Cancel') {
      }
      return;
    }
    callBack && callBack();
  };
  recordList: any = [];
  recordInfo: any = {};
  rank = 0;
  getPointsRecord = async () => {
    const { data, err }: any = await request(`api/points/record`, {
      method: 'GET',
      data: {},
    });
    if (err) {
      return;
    }
    this.recordList = data.data.list;
    this.recordInfo = data.data.info;
    this.rank = data.data.rank;
  };
  pointList: any = [];
  pointInfo: any = {};
  pointListLoading = false;
  pointListPage = 1;
  hasMore = true;
  getActivityPointsList = async () => {
    this.pointListLoading = true;
    const { data, err }: any = await request(
      `api/points/rank?page_size=30&&page=${this.pointListPage}`,
      {
        method: 'GET',
        data: {},
      },
    );
    this.pointListLoading = false;
    if (err) return false;
    if (this.pointListPage == 1) {
      this.pointList = data.data.list;
    } else {
      this.pointList = [...this.pointList, ...data.data.list];
    }
    if (data.total_page > this.pointListPage) {
      this.pointListPage = this.pointListPage + 1;
    } else {
      this.hasMore = false;
    }

    this.pointInfo = data.data.info;
    return true;
  };
  rules = '';
  startTime = '';
  endTime = '';
  time = '';
  desc = '';
  rule_image = '';
  platform_limit = '';
  weibo_name = '';
  qr_image = '';
  getConifg = async () => {
    const params = new URLSearchParams(window.location.search);
    const { data, err }: any = await request(`api/points/config`, {
      method: 'GET',
      data: {
        id: params.get('id'),
        gh_id: params.get('gh_id')
      },
    });
    if (err) {
      return;
    }
    this.rules = data.data.desc;
    this.startTime = data.data.start_time;
    this.endTime = data.data.end_time;
    this.time = data.data.time;
    this.desc = data.data.exchange_desc;
    this.rule_image = data.data.rule_image;
    this.platform_limit = data.data.platform_limit;
    this.weibo_name = data.data.weibo_name;
    this.qr_image = data.data.qr_image;
  };
  handleWxLogin = async () => {
    try {
      if (isWeiXin()) {
        const { data, err }: any = await request(`/api/repost/jsapi-config?url=${encodeURIComponent(window.location.href)}`);
        if (err) {
          return
        }
        // eslint-disable-next-line no-undef
        wx.config({
          debug: false, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
          appId: data.data.appId, // 必填，公众号的唯一标识
          signature: data.data.signature,
          timestamp: data.data.timestamp,
          nonceStr: data.data.nonceStr,
          jsApiList: ['chooseImage', 'previewImage'], // 必填，需要使用的 JS 接口列表
          openTagList: ["wx-open-launch-weapp"] // 必填，需要使用的 JS 接口列表
        });
      }
    } catch {

    }
  }
  userInfo = {};
  firstFlag = true;
  getUseInfo = async () => {
    if (!this.loginFlag) return;
    const params = new URLSearchParams(window.location.search);
    const { data, err }: any = await request(`api/points/userinfo`, {
      method: 'GET',
      data: {
        gh_id: params.get('gh_id')
      },
    });
    this.userInfo = data.data;
    if (!isWeiXin() && data.data.bind_platform && this.firstFlag) {
      this.firstFlag = false;
      openModal(data);
    }
  }
  bindWeibo = async (bindstr: string) => {
    if (!this.loginFlag) return;
    if (!isWeiXin()) return;
    const search = new URLSearchParams(window.location.search);
    search.delete("bind");
    const { data, err }: any = await request(`api/points/bind`, {
      method: 'POST',
      data: {
        bind: bindstr,
        id: search.get('id')
      },
    });
    search.delete("bind");
    window.history.replaceState(null, "", `?${search}`);
    if (data?.result === 'bind-success') {
      Toast.show("绑定微信成功！");
    }
  }
  loginFlag = false;
  setLogin = () => {
    if (localStorage.getItem('access-token')) {
      this.loginFlag = true;
    } else {
      this.loginFlag = false;
    }
  }
  exchangeLoading = false
  exchangeGifts = async (callBack: any) => {
    const search = new URLSearchParams(window.location.search);
    this.exchangeLoading = true
    try {
      const { data, err }: any = await request(`api/points/redpacket-exchange`, {
        method: 'POST',
        data: {
          id: search.get('id')
        },
      });
      this.exchangeLoading = false;
      if (data) {
        Toast.show("兑换成功，请注意查看微信红包消息！");
      }
      callBack && callBack();
    } catch {
      this.exchangeLoading = false;
    }
  }
  giftInfo = {
    remain_count: 0
  };
  getGiftsConfig = async () => {
    const search = new URLSearchParams(window.location.search);
    const { data, err }: any = await request(`api/points/redpacket-config`, {
      method: 'GET',
      data: {
        id: search.get('id')
      },
    });
    this.giftInfo = data.data;
  }
}
export default new store();
